module.exports = __webpack_public_path__ + "img/2-1.ca32b465.png";